// extracted by mini-css-extract-plugin
module.exports = {"menuIcon":"style_menuIcon__Wqwq0","container":"style_container__2PJ__","buttons":"style_buttons__2ufkZ"};